var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65941 9.17804C0.555808 9.11515 0.470959 9.02563 0.413697 8.91881C0.356435 8.81199 0.328853 8.69178 0.333822 8.57068C0.338791 8.44959 0.37613 8.33204 0.441951 8.23027C0.507773 8.1285 0.59967 8.04624 0.708076 7.99204L15.6667 0.333374L12.0487 15.142C12.0223 15.2484 11.9709 15.347 11.8986 15.4295C11.8264 15.5119 11.7354 15.5759 11.6334 15.616C11.5308 15.657 11.42 15.6734 11.3099 15.664C11.1998 15.6545 11.0935 15.6193 10.9994 15.5614L0.65941 9.17804Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.654 13.4967L5.584 15.5667C5.53617 15.6146 5.4752 15.6472 5.40881 15.6605C5.34243 15.6737 5.27361 15.6669 5.21108 15.641C5.14854 15.6151 5.0951 15.5712 5.05753 15.5149C5.01995 15.4586 4.99993 15.3924 5 15.3247V11.858L15.6667 0.333374",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.d03c829a.svg";
export { ForwardRef as ReactComponent };